







import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { ArticleData } from '@/model/faq';
import FaqMixin from '@/mixins/faq';

@Component
export default class FaqCard extends Mixins(FaqMixin) {
  @Prop({ default: {}, required: true })
  item!: ArticleData;

  mounted() {
    const elem = document.getElementById(this.item.id as string);
    if (this.search && elem) {
      let html: string = elem.innerHTML as string;
      html = html.replace(this.search, `<strong>${this.search}</strong>`);
      elem.innerHTML = html as string;
    }
  }
}
